import { render } from "./close.svg?vue&type=template&id=74be36cc"
const script = {}

import exportComponent from "C:\\Users\\craig\\Documents\\Websites\\lyle-scott\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__